import { useState } from "react";
import Box from "@amzn/awsui-components-console/box";
import Button from "@amzn/awsui-components-console/button";
import Modal from "@amzn/awsui-components-console/modal";
import SpaceBetween from "@amzn/awsui-components-console/space-between";

const DISMISSED_DATE_STORAGE_KEY =
  "marketing_demo_portal_notice_dismissed_date";
const MARKETING_DEMO_PORTAL_URL =
  "https://demos.marketing.aws.dev/collections/service-demos/amazon-connect";

function getLocalDate(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  return `${now.getFullYear()}-${month}-${day}`;
}

function shouldShowModal(today: string): boolean {
  try {
    return localStorage.getItem(DISMISSED_DATE_STORAGE_KEY) !== today;
  } catch {
    return true;
  }
}

export default function DailyMarketingPortalModal() {
  const [visible, setVisible] = useState(() =>
    shouldShowModal(getLocalDate())
  );

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_DATE_STORAGE_KEY, getLocalDate());
    } catch {
      // The modal can still be dismissed for this page load without storage.
    }
    setVisible(false);
  };

  return (
    <Modal
      closeAriaLabel="Close marketing demo portal notice"
      header="Find the latest Amazon Connect Customer demos"
      onDismiss={dismiss}
      size="medium"
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal" onClick={dismiss}>
              Stay on this portal
            </Button>
            <Button
              external
              href={MARKETING_DEMO_PORTAL_URL}
              onClick={dismiss}
              target="_blank"
              variant="primary"
            >
              Open Marketing Demo Portal
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      The latest Amazon Connect Customer demos are now available in the new
      Marketing Demo Portal. Visit the new portal to find the most current demo
      content.
    </Modal>
  );
}
